import client from './client';

export async function listRejectedRequests() {
  const { data } = await client.get('/rejected-requests');
  return data.data;
}

export async function rejectedRequestCount(since) {
  const { data } = await client.get('/rejected-requests/count', { params: { since: since || undefined } });
  return data.data.count;
}
